import React from 'react';

import InitMessageDropArea from './InitMessageDropArea';

// Actions
// import { addMessage } from 'store/modules/MessageModule'
// import { addComponent, updateComponentIndexPos, updateDepthCompIndexPos, updateMessageIndex } from '../store/modules/MessageModule';
import { onDropComponent } from './DropComponentCommonFunctions';
import { DnD_element_type } from '../common/ConstantValues';
// import { setMsgChanges } from '../store/modules/ResponseGenerationModule';

const InitMessageDropAreaContainer = (props) => {
  const { first, messageActions, placeholder } = props
  const {
    addMessage,
    addComponent,
    updateComponentIndexPos,
    updateDepthCompIndexPos,
    updateMessageIndex,
    setMsgChanges,
  } = messageActions

  let custom_minHeight = null
  let custom_index = null
  if (props) {
    const {minHeight, index} = props
    if (minHeight) {
      custom_minHeight = minHeight
      custom_index = index 
    }
  }
  const onMessageDropped = (e) => {
    setMsgChanges(true) // Set message changes to true
    const { index, prefix_type, type, cat_type } = e
    switch (cat_type) {
      case "MENU":
        // 메시지 추가
        if (type === "_MESSAGE") {
          addMessage(index)
          return
        }

        // 컴포넌트 메뉴 OnDrop
        addComponent({
          message_index: index,
          prefix_type: prefix_type,
          type: type,
        })
        break;

      case "REN_ELEM":
        // 랜더링 된 메시지 drop에 대한 로직 실행
        if (type === "MESSAGE") {
          const { messageIndex } = e
          updateMessageIndex({
            from: messageIndex,
            to: index,
            // to: index !== 0 ? index-1 : index,
          })
          return
        }
        if (prefix_type) { // 컴포넌트 메뉴 및 컴포넌트 OnDrop
          // Logic for depth components
          if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
            onDropComponent(updateDepthCompIndexPos, e, index)
            return
          }
          if (props.isDragging) { // 컴포넌트 OnDrop
            // const clac_message_target_index = first === undefined
            onDropComponent(updateComponentIndexPos, e, index) // 0: 제일 앞 인덱스 , -1: 제일 마지막 인덱스
            return
          }
        }
        break;

      default:
        
    }
  }

  return (
    <InitMessageDropArea
      minHeight={custom_minHeight}
      index={custom_index}
      onMessageDropped={onMessageDropped}
      placeholder={placeholder}
    />
  )
}

const mapStateToProps = (state) => ({
  isDragging: state.DnD.isDragging,
})

const mapDispatchToProps = (dispatch) => ({
  // addMessage: (arg) => {dispatch(addMessage(arg))},
  // addComponent: (arg) => {dispatch(addComponent(arg))},
  // updateComponentIndexPos: (arg) => {dispatch(updateComponentIndexPos(arg))},
  // updateDepthCompIndexPos: (arg) => {dispatch(updateDepthCompIndexPos(arg))},
  // updateMessageIndex: (arg) => {dispatch(updateMessageIndex(arg))},
  // setMsgChanges: (arg) => {dispatch(setMsgChanges(arg))},
})

export default InitMessageDropAreaContainer